<template>
    <div class="trans_body">
        <div class="trans_top">
            <div class="trans_tips">
                {{ $t('message.futures.transTip') }}
            </div>
            <div class="trans_panel">
                <!-- :class="{'move_reverse_top': , 'move_positive_top': }" -->
                <div class="panel_content content_top">
                    <span class="circle" />
                    <span class="dire_text">{{
                        $t('message.assets.from')
                    }}</span>
                    <el-select
                        v-model="transFrom"
                        @change="handlerGetCoinInfo($event, 'from')"
                    >
                        <el-option
                            v-for="(item, index) in transFromOption"
                            :key="index"
                            :value="item.value"
                            :label="item.label"
                            :disabled="item.disabled"
                        />
                    </el-select>
                </div>
                <div class="panel_center">
                    <span class="line" />
                    <el-button class="trans_btn" @click="handleChangeDirection">
                        <img src="../assets/futures/trans_logo.png" alt="" />
                    </el-button>
                </div>
                <!-- :class="{'move_reverse_bottom': , 'move_positive_bottom': }" -->
                <div class="panel_content content_bottom">
                    <span class="circle" />
                    <span class="dire_text">{{
                        $t('message.TransferMoney.to')
                    }}</span>
                    <el-select
                        v-model="transTo"
                        @change="handlerGetCoinInfo($event, 'to')"
                    >
                        <el-option
                            v-for="(item, index) in transToOption"
                            :key="index"
                            :value="item.value"
                            :label="item.label"
                            :disabled="item.disabled"
                        />
                    </el-select>
                </div>
            </div>
        </div>
        <div class="spea_line" />
        <div class="ope_box">
            <div class="label_text">
                {{ $t('message.futures.label1') }}
            </div>
            <div class="coin_select">
                <img v-if="coinInfo.img" :src="coinInfo.img" alt="" />
                <el-select
                    v-model="coin"
                    popper-class="transfer-select"
                    placeholder=""
                    filterable
                    :disabled="pickCurrency"
                    @change="coinSelect"
                >
                    <el-option
                        v-for="item in filterCoinListFilter"
                        :key="item.coinid"
                        :value="item.coinid"
                        :label="item.coin"
                    >
                        <div class="flex justify-between align-center">
                            <div class="flex align-center">
                                <img
                                    :src="item.img"
                                    alt=""
                                    class="w-22 h-22 m-r-8"
                                />
                                <div class="text-left">
                                    <div>{{ item.coin }}</div>
                                    <div class="font-12 m-t-2">
                                        {{ item.detail_code }}
                                    </div>
                                </div>
                            </div>
                            <div class="text-right">
                                <div class="white">
                                    {{ item.usenum }}
                                </div>
                                <div class="font-12 m-t-2 small">
                                    {{ rate_data.ratesymbol }}
                                    {{ item.use_num_tran_sort }}
                                </div>
                            </div>
                        </div>
                    </el-option>
                </el-select>
            </div>
            <div v-if="coinInfo.errorTips" class="font-12 text-D4575C m-t-4">
                {{ coinInfo.errorTips }}
            </div>
        </div>
        <div class="ope_box">
            <div class="label_box">
                <span class="label_text">{{
                    $t('message.futures.label2')
                }}</span>
                <span class="use_text">{{
                    `${$t('message.futures.useassets')}：${coinInfo.usenum}`
                }}</span>
            </div>
            <el-input v-model="quantity">
                <el-button
                    slot="append"
                    class="all_btn"
                    @click="quantity = coinInfo.use_num_input.toString()"
                >
                    {{ $t('message.common.all') }}
                </el-button>
            </el-input>
        </div>
        <div class="confirm_btn">
            <el-button @click="handleConfirm">
                {{ $t('message.common.confirm') }}
            </el-button>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
// import Decimal from 'decimal.js'
import { getNum, thousandths } from '@/utils';
import Trade from '@/api/futures/trade';
import { defaultCoin } from '@/enum/index';

export default {
    name: 'AccountTransfer',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        coinId: {
            type: Number,
            require: false
        },
        transferFrom: {
            type: String,
            default: 'otcLegalCurrency'
        }
    },
    data() {
        return {
            defaultCoin,
            transFrom: 1,
            transTo: 2,
            transFromOption: [],
            transToOption: [],
            digit: [],
            coin: null,
            quantity: null,
            changeDire: true,
            coinInfo: {
                usenum: '0.0'
            },
            transferType: 1,
            transferFromType: 'otcLegalCurrency',
            coinList: []
        };
    },
    computed: {
        ...mapState({
            futHoldDetail: state => state.futuresTrade.futHoldDetail,
            deliveryHoldDetail: state => state.deliveryTrade.futHoldDetail,
            transDetail: state => state.futuresTrade.transDetail,
            select_filter_assets: state => state.assets.select_filter_assets,
            otcLegalCurrencyList: state =>
                state.futuresTrade.otcLegalCurrencyList,
            holdAssetsList: state => state.deliveryTrade.holdAssetsList,
            rate_data: state => state.user.rate_data
        }),
        isIncludeUContractAccount() {
            return this.transFrom == 2 || this.transTo == 2;
        },
        isIncludeCoinContractAccount() {
            return this.transFrom == 4 || this.transTo == 4;
        },
        filterCoinListFilter() {
            let coinList = this.coinList;
            if (this.isIncludeCoinContractAccount) {
                coinList = this.coinList.filter(
                    item => item.coin !== this.defaultCoin
                );
            }
            if (this.isIncludeUContractAccount) {
                coinList = this.coinList.filter(
                    item => item.coin === this.defaultCoin
                );
            }
            return coinList;
        },
        pickCurrency() {
            if (
                (this.transFrom == 2 && this.transTo == 3) ||
                (this.transFrom == 3 && this.transTo == 2) ||
                (this.transFrom == 1 && this.transTo == 2) ||
                (this.transFrom == 2 && this.transTo == 1)
            ) {
                return true;
            }
            return false;
        }
    },
    watch: {
        visible: {
            handler(nVal) {
                if (nVal) {
                    this.init();
                }
            },
            immediate: true
        },
        coinId: {
            handler(newVal, oldVal) {},
            immediate: true
        }
    },
    methods: {
        init() {
            this.transferFromType = this.transferFrom;
            if (this.transferFromType == 'delivery') {
                this.transFrom = 1;
                this.transTo = 4;
            }
            if (this.transferFromType == 'spot') {
                this.transFrom = 3;
                this.transTo = 1;
            }
            if (this.transferFromType == 'otcLegalCurrency') {
                this.transFrom = 1;
                this.transTo = 3;
            }
            if (this.transferFromType == 'futures') {
                this.transFrom = 1;
                this.transTo = 2;
            }
            this.handlerTransMapOptions();
            this.handlerGetCoinInfo('init');
        },
        // 处理options
        handlerTransMapOptions() {
            const transFromOption = [];
            const transToOption = [];
            const transMap = {
                1: this.$t('message.assets.spot'),
                2: this.$t('message.assets.uContractAccount'),
                3: this.$t('message.assets.amount'),
                4: this.$t('message.assets.coinContractAccount')
            };
            for (const key in transMap) {
                let isFromDisable = false;
                let isToDisable = false;
                if (this.transFrom == key) {
                    isToDisable = true;
                }
                if (this.transTo == key) {
                    isFromDisable = true;
                }
                if (this.transTo == 2 && key == 4) {
                    isFromDisable = true;
                }
                if (this.transTo == 4 && key == 2) {
                    isFromDisable = true;
                }
                if (this.transFrom == 2 && key == 4) {
                    isToDisable = true;
                }
                if (this.transFrom == 4 && key == 2) {
                    isToDisable = true;
                }
                transFromOption.push({
                    value: Number(key),
                    label: transMap[key],
                    disabled: isFromDisable
                });
                transToOption.push({
                    value: Number(key),
                    label: transMap[key],
                    disabled: isToDisable
                });
            }
            this.transFromOption = transFromOption;
            this.transToOption = transToOption;
        },
        // 互换
        handleChangeDirection() {
            // const newTransFromOption = JSON.parse(
            //     JSON.stringify(this.transFromOption)
            // );
            // const newTransToOption = JSON.parse(
            //     JSON.stringify(this.transToOption)
            // );
            // this.transToOption = newTransFromOption;
            // this.transFromOption = newTransToOption;
            const transFrom = this.transFrom;
            const transTo = this.transTo;
            this.transFrom = transTo;
            this.transTo = transFrom;
            this.quantity = '';
            this.handlerGetCoinInfo('', 1);
        },
        // 切换现有场景（切换用）
        getTransforForm() {
            const transFrom = this.transFrom;
            const transTo = this.transTo;
            if (
                (transTo == 3 && transFrom == 1) ||
                (transTo == 1 && transFrom == 3)
            ) {
                this.transferFromType = 'otcLegalCurrency';
            }
            if (
                (transTo == 4 && transFrom == 1) ||
                (transTo == 1 && transFrom == 4)
            ) {
                this.transferFromType = 'delivery';
            }
            if (
                (transFrom == 2 && transTo == 1) ||
                (transFrom == 1 && transTo == 2)
            ) {
                this.transferFromType = 'futures';
            }
        },
        // 获取数据
        async handlerGetCoinInfo(e, type) {
            this.quantity = '';
            if (type) {
                // this.getTransforForm();
                this.handlerTransMapOptions();
            }
            const apiMap = {
                spot: 'futuresTrade/otcLegalCurrency',
                otcLegalCurrency: 'futuresTrade/otcLegalCurrency',
                futures: 'futuresTrade/getFutHoldDetail',
                delivery: 'deliveryTrade/getholdAssets'
            };
            const coinAssetApi = 'assets/getCoinAssetApi';
            // const api = apiMap[this.transferFromType];
            // 互换的时候不调用接口
            if (e) {
                // 所有现货资产列表
                // if (this.transferFrom != 'futures') {
                await this.$store.dispatch(coinAssetApi);
                // }
                // 列表数据
                // await this.$store.dispatch(api);

                for (let k in apiMap) {
                    // 列表数据
                    await this.$store.dispatch(apiMap[k]);
                }
            }
            this.getCoinData();
        },

        getCoinData() {
            const coinListLabelKey = {
                coin: 'coin',
                coinid: 'coinid',
                img: 'image',
                usenum: 'usenum',
                use_num_tran: 'use_num_rate',
                detail_code: 'detail_code',
                currencydigit: 'currencydigit'
            };
            const { transFrom, transTo } = this;
            let filterList = [];
            let list = [];
            // listMap.otcLegalCurrencyList 资金
            // filter_assets 现货
            // futHoldDetail u本位
            // listMap.delivery 币本位
            const map = {
                1: this.select_filter_assets.list,
                2: this.futHoldDetail,
                3: this.otcLegalCurrencyList,
                4: this.holdAssetsList
            };
            const transFromList = map[transFrom];
            const transToList = map[transTo];
            switch (Number(transFrom)) {
                case 1:
                    coinListLabelKey.coin = 'coin_code';
                    coinListLabelKey.coinid = 'coin_id';
                    coinListLabelKey.img = 'coin_code_image';
                    coinListLabelKey.usenum = 'use_num';
                    coinListLabelKey.currency_digit = 'currency_digit';
                    break;
                case 2:
                    coinListLabelKey.detail_code = 'coinfull';
                    coinListLabelKey.use_num_tran = 'balance_usdt';
                    break;
                case 3:
                    coinListLabelKey.img = 'coinimage';
                    coinListLabelKey.usenum = 'balance';
                    coinListLabelKey.detail_code = 'detailcode';
                    coinListLabelKey.use_num_tran = 'balance_usdt';
                    coinListLabelKey.amountdigit = 'amountdigit';
                    break;
                case 4:
                    coinListLabelKey.img = 'image';
                    coinListLabelKey.usenum = 'use_num';
                    coinListLabelKey.coinid = 'coin_id';
                    coinListLabelKey.use_num_tran = 'usd_num';
                    break;
            }
            transFromList.forEach(item => {
                transToList.forEach(cItem => {
                    if (
                        (item.coin || item.coin_code) ==
                        (cItem.coin_code || cItem.coin)
                    ) {
                        // 划转至u本位过滤
                        if (transTo == 2 && cItem.transferType != 2) return;
                        filterList.push(item);
                    }
                });
            });
            if (transFrom == 4 || transTo == 4) {
                // 币本位
                filterList = filterList.filter(
                    item =>
                        item.coin_code !== defaultCoin ||
                        item.coin !== defaultCoin
                );
            }
            if (transFrom == 2 || transTo == 2) {
                // u本位
                filterList = filterList.filter(
                    item =>
                        item.coin_code === defaultCoin ||
                        item.coin === defaultCoin
                );
                if (transFrom == 2) {
                    filterList = filterList.filter(
                        item => item.transferType === 2
                    );
                }
            }
            list = this.getCoinList(coinListLabelKey, filterList);
            if (!list || list.length <= 0) {
                return;
            }
            const ischoose = [];
            if (this.coinId) {
                list.forEach(item => {
                    if (item.coinid == this.coinId) {
                        ischoose.push(item);
                    }
                });
            }
            list = Array.from(new Set([...list, ...ischoose]));
            list.forEach(v => {
                v.use_num_tran_sort = getNum(
                    Number(v.use_num_tran) * this.rate_data.rate,
                    8
                );
                v.use_num_tran = thousandths(v.use_num_tran);
                v.use_num_input = v.usenum;
                v.usenum = thousandths(v.usenum);
            });
            list.sort((a, b) => {
                return b.use_num_tran - a.use_num_tran;
            });

            this.coinList = list;
            // this.coinListCopy = list.filter(v => {
            //     return Number(v.usenum) != 0;
            // });

            if (list && list.length > 0) {
                let coin_id = this.coinId;
                let usdc_list = list.filter(el => el.coin == this.defaultCoin);
                if (
                    transFrom == 2 ||
                    transTo == 2 ||
                    transFrom == 4 ||
                    transTo == 4
                ) {
                    coin_id = list[0].coinid;
                }
                if (usdc_list && usdc_list.length > 0) {
                    coin_id = usdc_list[0].coinid;
                }
                const map = this.coinList.find(item => item.coinid === coin_id);
                this.coin = coin_id || map?.coinid || list[0].coinid;
                this.coinInfo = map ? { ...map } : list[0] || {};
            } else {
                this.coinInfo.usenum = '0.0';
                this.coinInfo.use_num_input = 0;
                this.coinInfo.errorTips = this.$t('message.assets.tranError');
            }
        },
        getCoinList(keyMap, list) {
            if (list.length == 0) return;
            const coinList = [];
            const {
                coin,
                coinid,
                img,
                usenum,
                use_num_tran,
                detail_code,
                currency_digit,
                amountdigit,
                currencydigit
            } = keyMap;
            list.forEach(item => {
                let el = {
                    coin: item[coin],
                    coinid: item[coinid],
                    img: item[img],
                    usenum: item[usenum],
                    use_num_tran: item[use_num_tran],
                    detail_code: item[detail_code],
                    currency_digit: item[currency_digit],
                    amountdigit: item[amountdigit],
                    currencydigit: item[currencydigit]
                };
                if (Number(item[usenum])) {
                    coinList.unshift(el);
                } else {
                    coinList.push(el);
                }
            });
            // console.log(coinList, list, 'keyMap')
            return coinList;
        },
        // 获取类型
        getPostTransType() {
            const { transFrom, transTo } = this;
            // 现货转u本位
            if (transFrom == 1 && transTo == 2) return 1;
            // u本位转现货
            if (transFrom == 2 && transTo == 1) return 2;
            // 现货划转至资金
            if (transFrom == 1 && transTo == 3) return 3;
            // 资金划转至现货
            if (transFrom == 3 && transTo == 1) return 4;
            // 币本位划转现货
            if (transFrom == 4 && transTo == 1) return 5;
            // 现货划转币本位
            if (transFrom == 1 && transTo == 4) return 6;
            // 资金划转u本位
            if (transFrom == 3 && transTo == 2) return 7;
            // u本位划转资金
            if (transFrom == 2 && transTo == 3) return 8;
            // 资金划转至现货
            if (transFrom == 3 && transTo == 4) return 9;
            // 资金划转至现货
            if (transFrom == 4 && transTo == 3) return 10;
        },

        handleConfirm() {
            if (!this.quantity) {
                this.$message(this.$t('message.spot.enterNum'));
                return;
            }
            if (
                this.coinInfo.usenum == 0 ||
                Number(this.quantity) > Number(this.coinInfo.usenum)
            ) {
                this.$message(this.$t('message.comC.insufficientFunds'));
                return;
            }
            // if (this.quantity.indexOf('.') > -1) {
            //   const array = this.quantity.split('.')
            //   const cdigits = array[1]
            //   this.digit.forEach(item => {
            //     if (item.coinid || item.coin_id == this.coinInfo.coinid) {
            //       if (parseInt(item.currencydigit || item.amountdigit) < parseInt(cdigits.length)) {
            //         this.$message('超过该币种长度')
            //       } else {
            console.log(this.coinInfo);
            const transfer_type = this.getPostTransType();
            const params = {
                transfer_type: transfer_type,
                coinid: this.coin,
                num: this.quantity
            };
            this.$store.dispatch('futuresTrade/toTrans', params).then(() => {
                this.$message.success({
                    message: this.$t('message.common.successTips'),
                    duration: 1000
                });
                this.quantity = '';
                this.$emit('updateSuccess');
            });
            //       }
            //     }
            //   })
            // }
        },

        // 选择币种
        coinSelect(event) {
            this.coinList.forEach(item => {
                if (item.coinid == event) {
                    this.coinInfo = { ...item };
                }
            });
        }
    }
};
</script>
<style>
.transfer-select .el-select-dropdown__item {
    height: auto;
    padding: 5px 20px;
}

.transfer-select .el-select-dropdown__item div {
    line-height: 20px;
}

.transfer-select .el-select-dropdown__item .small {
    color: #848e9c !important;
}

.transfer-select .el-select-dropdown__item .white {
    color: #fff !important;
}
</style>
<style lang="scss" scoped>
@keyframes moveTop {
    0% {
        top: 20px;
    }

    100% {
        top: 81px;
    }
}

@keyframes moveBottom {
    0% {
        bottom: 19px;
    }

    100% {
        bottom: 81px;
    }
}

.trans_body {
    margin-top: 24px;
    border-top: 1px solid rgba($color: #47505a, $alpha: 0.5);
    padding: 24px 0 40px;

    .trans_top {
        padding: 0 40px 24px;
    }

    .trans_tips {
        font-size: 12px;
        font-family: PingFang_Regular;
        color: #848e9c;
        margin-bottom: 16px;
    }

    .trans_panel {
        padding: 20px 16px;
        background-color: #363c45;
        border-radius: 4px;
        position: relative;

        .panel_content {
            display: flex;
            align-items: center;
            width: 92%;

            .circle {
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                border: 1px solid #848e9c;
                margin-right: 16px;
            }

            .dire_text {
                font-size: 14px;
                font-weight: 500;
                color: #848e9c;
                margin-right: 16px;
            }

            .el-select {
                flex: 1;
            }
        }

        .content_top {
            position: absolute;
            top: 20px;
            left: 16px;
        }

        .content_bottom {
            position: absolute;
            bottom: 19px;
            left: 16px;
        }

        .move_reverse_top {
            animation: 1s moveTop;
        }

        .move_reverse_bottom {
            animation: 1s moveBottom;
        }

        .move_positive_top {
            animation: 1s moveTop;
            animation-direction: reverse;
        }

        .move_positive_bottom {
            animation: 1s moveBottom;
            animation-direction: reverse;
        }

        .panel_center {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px 10px 20px 3px;

            .line {
                display: inline-block;
                height: 40px;
                border: 1px dashed #848e9c;
            }

            .trans_btn {
                border: none;
                background-color: transparent;
                padding: 0;
                margin: 0;
                padding-top: 8px;

                span {
                    & > img {
                        width: 16px;
                        height: 16px;
                        vertical-align: middle;
                    }
                }
            }
        }
    }

    .spea_line {
        width: 100%;
        height: 1px;
        background-color: rgba($color: #47505a, $alpha: 0.5);
    }

    .ope_box {
        padding: 16px 40px 0;

        .label_text {
            font-size: 14px;
            font-weight: 500;
            color: $basicWhite;
            margin-bottom: 8px;
        }

        .label_box {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-bottom: 8px;

            & > .label_text {
                margin-bottom: 0;
            }
        }

        .use_text {
            font-size: 12px;
            color: #848e9c;
        }

        .el-select {
            width: 100%;
            height: 40px;
            border: 1px solid #47505a;
            border-radius: 4px;

            ::v-deep {
                .el-input {
                    height: 100%;
                }

                .el-input__suffix {
                    padding: 11px 0;
                }

                .el-input__suffix-inner {
                    padding-left: 5px;
                    border-left: 1px solid #636b75;
                }
            }
        }

        & > .el-input {
            height: 40px;
            border-radius: 4px;
            border: 1px solid #47505a;
        }

        .all_btn {
            font-weight: 500;
            color: $basicColor;
            padding: 0 12px;
        }

        .coin_select {
            display: flex;
            align-items: center;
            position: relative;

            & > img {
                position: absolute;
                top: 12px;
                left: 13px;
                width: 16px;
                height: 16px;
                z-index: 1;
            }

            ::v-deep {
                .el-input__inner {
                    padding-left: 37px;
                }
            }
        }
    }

    .confirm_btn {
        width: 100%;
        padding: 0 40px;
        margin-top: 40px;

        .el-button {
            width: 100%;
            border: none;
            background-color: $basicColor;
            font-size: 16px;
            font-weight: 500;
            color: #070707;
        }
    }

    ::v-deep {
        .el-input__inner {
            border: none;
            color: $basicWhite !important;
            font-size: 14px;
        }

        .el-input-group__append {
            width: 52px;
            text-align: center;
            border: none;
        }
    }
}
</style>
